/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Workspace_SubtitleInputs */

const en_dashboard_workspace_subtitle = /** @type {(inputs: Dashboard_Workspace_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your active stage assignments directly.`)
};

const pt_br2_dashboard_workspace_subtitle = /** @type {(inputs: Dashboard_Workspace_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerencie suas atribuições ativas diretamente.`)
};

/**
* | output |
* | --- |
* | "Manage your active stage assignments directly." |
*
* @param {Dashboard_Workspace_SubtitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_workspace_subtitle = /** @type {((inputs?: Dashboard_Workspace_SubtitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Workspace_SubtitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_workspace_subtitle(inputs)
	return pt_br2_dashboard_workspace_subtitle(inputs)
});